import React from 'react';
import { LayoutGroup, motion } from 'framer-motion';
import { FlaskConical, Rocket, Users } from 'lucide-react';
import { useStepCycle } from '../../hooks/useStepCycle';
import { EASE_IN_OUT, EASE_OUT } from '../../utils/motion';
const modules = ['Rollen', 'Aufträge', 'Lager', 'ERP', 'Mobil', 'Reports'];
export function GoLiveIllustration() {
  const step = useStepCycle(modules.length + 3, 900);
  const live = Math.min(step, modules.length);
  const zones = [{
    key: 'test',
    title: 'Testsystem',
    icon: FlaskConical,
    items: modules.slice(live)
  }, {
    key: 'prod',
    title: 'Produktivsystem',
    icon: Rocket,
    items: modules.slice(0, live)
  }];
  return <div className="absolute inset-0 p-6 xl:p-8 flex flex-col gap-4" data-id="element-44" data-mp="1556j6j6b35qw">
      <LayoutGroup data-id="element-45" data-mp="1170f5iwur49o">
        <div className="flex-1 grid grid-cols-2 gap-4 min-h-0" data-id="element-46" data-mp="113l1mkitu3ad">
          {zones.map(zone => {
          const isProd = zone.key === 'prod';
          const Icon = zone.icon;
          return <div key={zone.key} className={`rounded-2xl p-4 flex flex-col ${isProd ? 'bg-white ring-2 ring-accent' : 'bg-white/60 border-2 border-dashed border-primary/15'}`} data-id="element-47" data-mp="32z590zxwwbn1">
                <div className="flex items-center gap-2 mb-3" data-id="element-48" data-mp="qpf670bk4c3z">
                  <Icon className="w-4 h-4 text-primary" data-id="element-49" data-mp="viqez6zxj2yj" />
                  <span className="text-sm font-semibold text-primary" data-id="element-50" data-mp="10hbfl7j3foni">{zone.title}</span>
                  {isProd && <span className="ml-auto flex items-center gap-1.5 text-[11px] font-semibold text-primary" data-id="element-51" data-mp="14hvb66o0qk7j">
                      <motion.span className="w-2 h-2 rounded-full bg-accent" animate={{
                  opacity: [1, 0.3, 1]
                }} transition={{
                  duration: 1.6,
                  repeat: Infinity,
                  ease: 'linear'
                }} data-id="element-52" data-mp="19j18khsmivne" />
                      Live
                    </span>}
                </div>
                <div className="grid grid-cols-2 gap-2 content-start" data-id="element-53" data-mp="386ye1zmpvz52">
                  {zone.items.map(m => <motion.div key={m} layoutId={`golive-${m}`} transition={{
                layout: {
                  duration: 0.45,
                  ease: EASE_IN_OUT
                }
              }} className={`h-10 rounded-lg flex items-center justify-center text-xs font-semibold ${isProd ? 'bg-accent text-primary' : 'bg-white text-primary border border-gray-200'}`} data-id="element-54" data-mp="346o64hfd6ynk">
                      {m}
                    </motion.div>)}
                </div>
              </div>;
        })}
        </div>
      </LayoutGroup>

      <div className="bg-white rounded-2xl shadow-sm px-5 py-4" data-id="element-55" data-mp="eofjxp6khdyi">
        <div className="flex items-center justify-between text-sm mb-2" data-id="element-56" data-mp="emkvi0w373po">
          <span className="font-semibold text-primary flex items-center gap-2" data-id="element-57" data-mp="9rfdhd5t296v">
            <Users className="w-4 h-4" data-id="element-58" data-mp="tcp8j14d6hvd" />
            Ihr Team arbeitet bereits damit
          </span>
          <span className="text-text-secondary" data-id="element-59" data-mp="xby4mcmvmru3">
            {live} von {modules.length} Modulen produktiv
          </span>
        </div>
        <div className="h-2 rounded-full bg-bg-alt overflow-hidden" data-id="element-60" data-mp="jfkpvb9q94jb">
          <motion.div className="h-full bg-accent rounded-full" initial={false} animate={{
          width: `${live / modules.length * 100}%`
        }} transition={{
          duration: 0.4,
          ease: EASE_OUT
        }} data-id="element-61" data-mp="oazxvml2067t" />
        </div>
      </div>
    </div>;
}